<template>
  <el-dialog
    title="上传小票"
    :visible.sync="selfVisible"
    width="800px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="姓名：" prop="userId">
        <el-select
          v-model="form.userId"
          filterable
          placeholder="请选择"
          @change="selectUserInfo"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.id"
            :label="item.userName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称：" prop="shopId" class="nomargin">
        <el-select v-model="form.shopId" filterable placeholder="请选择" @change="selectShopInfo">
          <el-option
            v-for="item in shopOptions"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小票：" class="uploadImg">
        <upload
          :url="form.ticketUrl"
          @successUpload="handleSuccessUpload"
          prompt
        />
      </el-form-item>
    </el-form>
     <el-row type="flex" justify="center" style="margin-top: 60px;">
        <el-button
          :loading="loading"
          class="standard-button"
          style="margin-right: 10px;"
          @click="handleClose"
        >取消</el-button>
        <el-button
          class="standard-button"
          type="primary"
          :loading="loading"
          @click="handlerConfirm"
        >确认</el-button>
      </el-row>
  </el-dialog>
</template>

<script>
import { getShopUserList, getAppShopList } from '@/api/audit';
import { validCurrency } from '@/utils/validate';
import Upload from '@/components/Upload/index.vue';

export default {
  name: 'addDialog',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      selfVisible: false,
      form: {
        userId: '',
        userName: '',
        userPhone: '',
        shopId: '',
        shopName: '',
        ticketUrl: '',
      },
      userOptions: [],
      shopOptions: [],
      rules: {
        userId: [
          { required: true, message: '姓名不能为空', trigger: 'change' },
        ],
        shopId: [
          { required: true, message: '店铺名称不能为空', trigger: 'change' },
          { validator: validNumber, trigger: 'change' },
        ],
      },
    };
  },
  components: {
    Upload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getShopUserList();
    this.getAppShopList();
  },
  methods: {
    // 获取会员列表
    getShopUserList() {
      getShopUserList().then((res) => {
        if (res.success) {
          this.userOptions = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取店铺列表
    getAppShopList() {
      getAppShopList().then((res) => {
        if (res.success) {
          this.shopOptions = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    selectUserInfo(id) {
      let obj = {};
      obj = this.userOptions.find((item) => item.id === id);
      const { userName, userPhone } = obj;
      this.form.userName = userName;
      this.form.userPhone = userPhone;
    },
    selectShopInfo(id) {
      let obj = {};
      obj = this.shopOptions.find((item) => item.id === id);
      const { shopName } = obj;
      this.form.shopName = shopName;
    },
    handlerConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { ticketUrl } = this.form;
          if (!ticketUrl) {
            this.$message.warning('请上传小票');
          } else {
            this.$emit('confirm', this.form);
          }
          return true;
        }
        return false;
      });
    },
    handleSuccessUpload(url) {
      this.form.ticketUrl = url;
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleClose() {
      this.form.userName = '';
      this.form.userPhone = '';
      this.form.shopName = '';
      this.form.ticketUrl = '';
      this.resetForm();
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.el-form
  flex-column()
  padding-left 120px
>>>.el-dialog__header
  padding 13px 20px
  .el-dialog__headerbtn
    top 16px
>>>.el-input
  width 400px !important
.uploadImg
  width 390px
  flex-row()
  >>>.el-form-item__content
    margin-left 0 !important
.nomargin
  margin-bottom 0 !important
</style>
